import { Brand, FeatureFlagUser, ParkId, Token } from '@/types';

export enum ClientType {
  Android,
  iOS,
  Web,
}

export interface InitialBridgeContext {
  /** user token */
  token: Token | null;
  /** client private key in PEM format */
  clientPrivateKeyPem: string | null;
  /** drift between client and server in seconds */
  driftInSeconds: number | null;
  brand: Brand | null;
  parkId: ParkId | null;
  featureFlagUser?: FeatureFlagUser;
  /** user is currently in the park*/
  isInPark: boolean;
  /** users current latitude sent from the app*/
  lat: number;
  /** users current longitude sent from the app*/
  lng: number;
}

export interface IInteropBridge {
  clientType: ClientType;
  getInitialBridgeContext(): Promise<InitialBridgeContext>;
  launchEComm(path: string): void;
  launchExternalWeb(url: string): void;
  launchAccountPage(): void;
  launchNativeSignIn(): void;
  launchNativeSignUp(): void;
  launchPhoneCall(phoneNumber: string): void;
  launchLeaveFeedback(message: string): void;
  launchNativeMyPurchasesModal(): void;
  launchNativeMyPassAndBenefitsModal(): void;
  launchBilling(): void;
}
